import AppRecord from './AppRecord.js'

class ManualFee extends AppRecord {
}
export default ManualFee
